module.exports = __webpack_public_path__ + "img/logoempresa.2daa649d.png";